module.exports = __webpack_public_path__ + "img/google_pay.1aaebe95.svg";